import { AxiosInstance } from 'axios';
import { removeIfUndefined } from 'lib/util';

interface JobsResponse {
  jobs: GreenhouseJob[];
}

interface GreenhouseJob {
  id: number;
  title: string;
  content: string;
  updated_at: string;
  location: {
    name: string;
  } | null;
  metadata:
    | {
        name: string;
        value: string;
      }[]
    | null;
  departments:
    | {
        name: string;
      }[]
    | null;
}

export interface Job {
  id: number;
  title: string;
  updated_at: string;
  location: string;
  state: string;
  department: string;
  brand?: string;
}

export type JobWithContent = Job & {
  content: string;
};

export interface Board {
  id: string;
  name: string;
}

export async function getJobList(
  client: AxiosInstance,
  boardId: string,
  brand?: string
): Promise<Job[]> {
  return (await client.get<JobsResponse>(`/${boardId}/jobs?content=true`)).data.jobs
    .map(toJob)
    .filter((job) => !brand || brand === job.brand);
}

export async function getBoard(client: AxiosInstance, boardId: string): Promise<Board> {
  return { id: boardId, ...(await client.get<{ name: string }>(`/${boardId}`)).data };
}

export async function getJob(
  client: AxiosInstance,
  boardId: string,
  jobId: string
): Promise<JobWithContent> {
  return toJobWithContent((await client.get<GreenhouseJob>(`/${boardId}/jobs/${jobId}`)).data);
}

function toJob({ id, title, updated_at, location, metadata, departments }: GreenhouseJob): Job {
  const jobMetadata = metadata ?? [];
  const departmentName = departments?.[0]?.name?.trim() || '';

  if (jobMetadata.length === 0) {
    console.log('jobMetadata', { id, title });
  }

  return {
    id,
    title,
    location: location?.name || '',
    updated_at,
    state: jobMetadata.find(({ name }) => name === 'State')?.value || '',
    ...removeIfUndefined({ brand: jobMetadata.find(({ name }) => name === 'Brand')?.value || '' }),
    department: departmentName,
  };
}

function toJobWithContent(job: GreenhouseJob): JobWithContent {
  return {
    ...toJob(job),
    content: job.content,
  };
}
